import { Fragment } from 'react'

import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'

import { Attribute } from 'components/OpenApi/Attribute'
import { useApiContext } from 'components/OpenApi/context'

import { List } from '../../Common'

type Props = {
	data: OpenApi3.MediaTypeObject

	linkPrefix: string
}

export const Payload = ({ data, linkPrefix }: Props) => {
	const { getRefValue } = useApiContext()
	if ('$ref' in data) {
		console.error('Rendering of referenced request or response objects are not yet supported')
		return null
	}

	return (
		<List>
			{(() => {
				if (data.schema && '$ref' in data.schema) {
					const schema = getRefValue(data.schema.$ref)
					if (schema && 'properties' in schema && schema.properties) {
						return (
							<Fragment>
								{Object.entries(schema.properties).map(([key, value], index) => (
									<Attribute
										key={index}
										name={key}
										value={value}
										isRequired={schema.required?.includes(key) ?? false}
										linkPrefix={linkPrefix}
										isExpandedInitially={Object.keys(schema.properties!).length === 1}
									/>
								))}
							</Fragment>
						)
					}
					if (schema && ('items' in schema || 'oneOf' in schema || 'allOf' in schema)) {
						return <Attribute name='' value={schema} linkPrefix={linkPrefix} isExpandedInitially isRequired />
					}
				} else {
					return <Attribute name='' value={data.schema!} linkPrefix={linkPrefix} isRequired />
				}
			})()}
		</List>
	)
}
